<template>
  <div :class="[colSizes, 'mb-3']">
    <router-link
      tag="div"
      :to="{
        name: ROUTE_FOOD_EDIT,
        params: { id: id, name: foodItem.name }
      }"
      :id="id"
      class="card card-colorful"
      :style="{ backgroundColor: cardColor }"
    >
      <h5 class="card-header">
        {{ foodItem.name }}
        <span class="badge badge-secondary float-right">{{
          foodItem.amount
        }}</span>
      </h5>
      <div class="card-body">
        <p class="card-text">
          <span
            class="badge category-badge"
            v-for="(category, id) in foodItem.categories"
            :key="categoryById(category).created"
            :id="'badge' + id"
            :style="{
              backgroundColor: '#' + categoryById(category).color + '80'
            }"
            >{{ categoryById(category).name }}</span
          >
        </p>
        <p v-if="foodItem.notes" class="card-text small">
          {{ foodItem.notes }}
        </p>
      </div>
    </router-link>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { isEmptyObject } from "./../../tools";
import { ROUTE_FOOD_EDIT, COL_SIZES_CARD_FULL_WIDTH } from "./../../constants";

export default {
  name: "FoodCard",
  data() {
    return { ROUTE_FOOD_EDIT };
  },
  props: {
    foodItem: { type: Object, required: true },
    id: { type: String, required: true },
    colSizes: {
      type: String,
      required: false,
      default() {
        return COL_SIZES_CARD_FULL_WIDTH;
      }
    }
  },
  computed: {
    ...mapGetters(["categoryById"]),
    cardColor() {
      // show card in color of current category (via ID in route) or in color of first category outside of category view
      let color = "e5e5e5";
      if (!isEmptyObject(this.foodItem.categories)) {
        const cat = this.$route.params.id
          ? this.$route.params.id
          : this.foodItem.categories[0];
        color = this.categoryById(cat).color;
      }
      return "#" + color + "ff";
    }
  }
};
</script>

<style scoped lang="scss"></style>
